import { ApolloClient, InMemoryCache } from "@apollo/client";

export const createApolloClient = () => {
	return new ApolloClient({
		// @ts-ignore
		uri: process.env.REACT_APP_API_URL,
		cache: new InMemoryCache(),
	});
};
